module.exports = __webpack_public_path__ + "img/service-setting-item3.87230924.png";